import actions from 'modules/booking/destroy/bookingDestroyActions';
import destroyReducers from 'modules/shared/destroy/destroyReducers';

export default destroyReducers(actions);
